const compareLettingAgentsSlug = 'compare-letting-agents';

const compareLettingAgentsHeading = 'Compare letting agents near your rental';
const shortHeadingLength = 24;

export const withCompareLettingAgentsHeading = <
  T extends { hero: { title: string } },
>(
  slug: string,
  page: T,
): T => {
  if (slug !== compareLettingAgentsSlug) {
    return page;
  }

  if (page.hero.title.trim().length >= shortHeadingLength) {
    return page;
  }

  return {
    ...page,
    hero: {
      ...page.hero,
      title: compareLettingAgentsHeading,
    },
  };
};
